import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useTranslation } from 'react-i18next';
import { useAppTheme } from '../../theme/AppThemeProvider';

export const ThemeToggle = () => {
  const { mode, toggleColorMode } = useAppTheme();
  const { t } = useTranslation();
  const label = t(mode === 'light' ? 'enableDarkTheme' : 'enableLightTheme');

  return (
    <Tooltip title={label}>
      <IconButton
        color="inherit"
        aria-label={label}
        onClick={toggleColorMode}
        sx={{ width: 40, height: 40, flexShrink: 0 }}
      >
        {mode === 'light' ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
};
